var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"subnav2 flex flex-c"},[_c('ul',{staticClass:"flex"},_vm._l((_vm.linkData),function(item,index){return _c('li',{key:index,class:[index==_vm.tabIndex?'selected':'']},[_c('router-link',{staticClass:"link",attrs:{"to":item.link}},[_vm._v(_vm._s(item.label))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }